import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getActiveUser, getIsLoggedIn } from 'app/selectors'
import { isReleased } from 'utilities'
import { User } from 'api'

export function PersonalVerificationRedirect(): React.ReactElement | null {
  const activeUser = useSelector(getActiveUser) || {}
  const isLoggedIn = useSelector(getIsLoggedIn)
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (
      activeUser.rolesAttributes?.length > 0 &&
      isReleased('personal_verification_for_existing_users') &&
      isLoggedIn &&
      location.pathname !== '/my_account/personal_verification' &&
      shouldUserVerifyPersonalInfo(activeUser)
    ) {
      history.push('/my_account/personal_verification')
    }
  }, [location.pathname, activeUser, history, isLoggedIn, activeUser.rolesAttributes])

  return null
}

function shouldUserVerifyPersonalInfo(user: User): boolean {
  if (user.customerId) return false
  if (user.rotessaStaff) return false

  const requiredFields = [
    user.firstName,
    user.lastName,
    user.dateOfBirth,
    user.occupation,
    user.addressAttributes,
    user.addressAttributes?.address1,
    user.addressAttributes?.city,
    user.addressAttributes?.postalCode,
    user.addressAttributes?.provinceCode,
    user.rolesAttributes,
  ]

  // Make sure required fields are not empty
  if (requiredFields.some((field) => !field)) return true

  // Make sure positions for each client are set
  if (user.rolesAttributes?.some((role) => !role.position)) return true

  return false
}
